import Cookies from 'universal-cookie';
import { getCmpQueryMap } from 'Utils/CmpQuery';
import { FNC_COOKIE_NAME, FNC_MC_EXPECTED_VALUE } from 'Utils/Constants';
import { getDefaultConfig } from 'Utils/Store';

const validPeriod = 172800000; // 48hrs

const cookies = new Cookies();

const setFNCCookie = (data) => {
  if (data) {
    const { cookieDomain } = getDefaultConfig();
    const now = new Date();
    const expires = new Date(now.getTime() + validPeriod);
    const options = { path: '/', expires, domain: cookieDomain };
    cookies.set(FNC_COOKIE_NAME, data, options);
  }
};

const formatFNCCookie = (queryStr) => queryStr.replace('?', '');

export const checkAndSetFNCCookie = () => {
  try {
    const cmpQueryMap = getCmpQueryMap();
    const isTrafficFromFNC = cmpQueryMap?.get('mc') === FNC_MC_EXPECTED_VALUE;
    if (isTrafficFromFNC) {
      const searchStr = window.location.search;
      const fmcCookie = formatFNCCookie(searchStr);
      setFNCCookie(fmcCookie);
    }
  } catch (e) {
    console.debug(`FNCCookie failed with the error: ${e}`);
  }
};
